__turbopack_context__.v({
  "border": "trustedBadgeFooter-module-scss-module__dGOBqG__border",
  "container": "trustedBadgeFooter-module-scss-module__dGOBqG__container",
  "trustedBadgeFooter": "trustedBadgeFooter-module-scss-module__dGOBqG__trustedBadgeFooter",
  "trustedBagdeSection": "trustedBadgeFooter-module-scss-module__dGOBqG__trustedBagdeSection",
});
